{
  "version": 1,
  "source": "docs/reference/painting-1538-amsterdam-museum.jpg",
  "sourceSize": [6692, 4866],
  "notes": "Nineteen distinguishable Voorburgwal-facing roof masses and fourteen exposed Achterburgwal-facing gable/roof masses in the narrow strip beside the Oude Kerk. Order and source picks are observations; allocation to the retained Stoofsteeg\u2013Oudekennissteeg block, end-of-row assignments, frontage widths, storeys, hidden rear walls and oblique plot axes are estimates. Achterburgwal roof materials are partly obscured and interpreted, not individually proven. Counts identify readable masses, not recovered medieval properties. Both sources show opposing canal-street rows; no evidence justifies anonymous middle filler. See docs/oudezijde-blocks.md, Paired rows between the canals. The initial one-mass/one-house fit produced oversized 10\u201315 m fronts. The explicit plots arrays now subdivide broad masses into narrower estimated street properties. The 65 resulting properties are inferred; the 33 original roof/gable picks and their order remain distinct observations. These subdivisions are not established cadastral boundaries or additional visible roofs.",
  "rows": [
    {
      "id": "oudekerk-island-voorburgwal",
      "source": "quay-oudezijds-voorburgwal-3",
      "side": "right",
      "from": 419,
      "to": 592,
      "depth": 21,
      "shear": -0.2,
      "evidence": "painted",
      "houses": [
        {
          "id": "oudekerk-island-voorburgwal-01",
          "widthWeight": 1.15,
          "storeys": 3,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2374, 2529],
          "plots": [
            {
              "id": "oudekerk-island-voorburgwal-01/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-voorburgwal-01/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-voorburgwal-02",
          "widthWeight": 0.9,
          "storeys": 3,
          "roof": "slate",
          "gable": "plain",
          "paintedPixel": [2391, 2554],
          "plots": [
            {
              "id": "oudekerk-island-voorburgwal-02/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-voorburgwal-02/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-voorburgwal-03",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2402, 2568],
          "plots": [
            {
              "id": "oudekerk-island-voorburgwal-03/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-voorburgwal-03/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-voorburgwal-04",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "slate",
          "gable": "plain",
          "paintedPixel": [2411, 2600],
          "plots": [
            {
              "id": "oudekerk-island-voorburgwal-04/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-voorburgwal-04/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-voorburgwal-05",
          "widthWeight": 0.6,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2420, 2613],
          "plots": [
            {
              "id": "oudekerk-island-voorburgwal-05/a",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-voorburgwal-06",
          "widthWeight": 0.65,
          "storeys": 2,
          "roof": "slate",
          "gable": "plain",
          "paintedPixel": [2429, 2630],
          "plots": [
            {
              "id": "oudekerk-island-voorburgwal-06/a",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-voorburgwal-07",
          "widthWeight": 1.1,
          "storeys": 3,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2436, 2644],
          "plots": [
            {
              "id": "oudekerk-island-voorburgwal-07/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-voorburgwal-07/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-voorburgwal-08",
          "widthWeight": 1.05,
          "storeys": 3,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2452, 2668],
          "plots": [
            {
              "id": "oudekerk-island-voorburgwal-08/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-voorburgwal-08/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-voorburgwal-09",
          "widthWeight": 1.05,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2467, 2693],
          "plots": [
            {
              "id": "oudekerk-island-voorburgwal-09/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-voorburgwal-09/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-voorburgwal-10",
          "widthWeight": 0.85,
          "storeys": 3,
          "roof": "slate",
          "gable": "plain",
          "paintedPixel": [2484, 2713],
          "plots": [
            {
              "id": "oudekerk-island-voorburgwal-10/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-voorburgwal-10/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-voorburgwal-11",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2501, 2740],
          "plots": [
            {
              "id": "oudekerk-island-voorburgwal-11/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-voorburgwal-11/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-voorburgwal-12",
          "widthWeight": 0.7,
          "storeys": 2,
          "roof": "slate",
          "gable": "plain",
          "paintedPixel": [2517, 2761],
          "plots": [
            {
              "id": "oudekerk-island-voorburgwal-12/a",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-voorburgwal-13",
          "widthWeight": 1.1,
          "storeys": 3,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2534, 2781],
          "plots": [
            {
              "id": "oudekerk-island-voorburgwal-13/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-voorburgwal-13/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-voorburgwal-14",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2550, 2801],
          "plots": [
            {
              "id": "oudekerk-island-voorburgwal-14/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-voorburgwal-14/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-voorburgwal-15",
          "widthWeight": 0.9,
          "storeys": 3,
          "roof": "slate",
          "gable": "plain",
          "paintedPixel": [2564, 2821],
          "plots": [
            {
              "id": "oudekerk-island-voorburgwal-15/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-voorburgwal-15/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-voorburgwal-16",
          "widthWeight": 1.1,
          "storeys": 3,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2581, 2843],
          "plots": [
            {
              "id": "oudekerk-island-voorburgwal-16/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-voorburgwal-16/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-voorburgwal-17",
          "widthWeight": 0.85,
          "storeys": 3,
          "roof": "slate",
          "gable": "plain",
          "paintedPixel": [2597, 2864],
          "plots": [
            {
              "id": "oudekerk-island-voorburgwal-17/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-voorburgwal-17/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-voorburgwal-18",
          "widthWeight": 1.05,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2611, 2886],
          "plots": [
            {
              "id": "oudekerk-island-voorburgwal-18/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-voorburgwal-18/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-voorburgwal-19",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2625, 2907],
          "plots": [
            {
              "id": "oudekerk-island-voorburgwal-19/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-voorburgwal-19/b",
              "widthWeight": 1
            }
          ]
        }
      ],
      "opposite": "quay-oudezijds-achterburgwal"
    },
    {
      "id": "oudekerk-island-achterburgwal",
      "source": "quay-oudezijds-achterburgwal",
      "side": "left",
      "from": 401,
      "to": 579,
      "depth": 20,
      "shear": -0.15,
      "evidence": "painted",
      "houses": [
        {
          "id": "oudekerk-island-achterburgwal-01",
          "widthWeight": 1.15,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2303, 2553],
          "plots": [
            {
              "id": "oudekerk-island-achterburgwal-01/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-achterburgwal-01/b",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-achterburgwal-01/c",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-achterburgwal-02",
          "widthWeight": 1.25,
          "storeys": 3,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2335, 2603],
          "plots": [
            {
              "id": "oudekerk-island-achterburgwal-02/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-achterburgwal-02/b",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-achterburgwal-02/c",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-achterburgwal-03",
          "widthWeight": 0.95,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2374, 2648],
          "plots": [
            {
              "id": "oudekerk-island-achterburgwal-03/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-achterburgwal-03/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-achterburgwal-04",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2392, 2674],
          "plots": [
            {
              "id": "oudekerk-island-achterburgwal-04/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-achterburgwal-04/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-achterburgwal-05",
          "widthWeight": 0.85,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2410, 2708],
          "plots": [
            {
              "id": "oudekerk-island-achterburgwal-05/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-achterburgwal-05/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-achterburgwal-06",
          "widthWeight": 1.05,
          "storeys": 3,
          "roof": "slate",
          "gable": "plain",
          "paintedPixel": [2428, 2726],
          "plots": [
            {
              "id": "oudekerk-island-achterburgwal-06/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-achterburgwal-06/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-achterburgwal-07",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2447, 2750],
          "plots": [
            {
              "id": "oudekerk-island-achterburgwal-07/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-achterburgwal-07/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-achterburgwal-08",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2467, 2785],
          "plots": [
            {
              "id": "oudekerk-island-achterburgwal-08/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-achterburgwal-08/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-achterburgwal-09",
          "widthWeight": 0.95,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2488, 2811],
          "plots": [
            {
              "id": "oudekerk-island-achterburgwal-09/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-achterburgwal-09/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-achterburgwal-10",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2500, 2840],
          "plots": [
            {
              "id": "oudekerk-island-achterburgwal-10/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-achterburgwal-10/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-achterburgwal-11",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2519, 2866],
          "plots": [
            {
              "id": "oudekerk-island-achterburgwal-11/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-achterburgwal-11/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-achterburgwal-12",
          "widthWeight": 1.1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2533, 2897],
          "plots": [
            {
              "id": "oudekerk-island-achterburgwal-12/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-achterburgwal-12/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-achterburgwal-13",
          "widthWeight": 0.95,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2552, 2928],
          "plots": [
            {
              "id": "oudekerk-island-achterburgwal-13/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-achterburgwal-13/b",
              "widthWeight": 1
            }
          ]
        },
        {
          "id": "oudekerk-island-achterburgwal-14",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [2573, 2952],
          "plots": [
            {
              "id": "oudekerk-island-achterburgwal-14/a",
              "widthWeight": 1
            },
            {
              "id": "oudekerk-island-achterburgwal-14/b",
              "widthWeight": 1
            }
          ]
        }
      ],
      "opposite": "quay-oudezijds-voorburgwal-3"
    }
  ]
}
